import { render, staticRenderFns } from "./PurchaseOrderOrderSummaryDatatable.vue?vue&type=template&id=84bb656c"
import script from "./PurchaseOrderOrderSummaryDatatable.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseOrderOrderSummaryDatatable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports